'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $ct_Lmealorama_MealType__I__T__T__($thiz, num, name, description) {
  $thiz.uC = num;
  $thiz.rk = name;
  $thiz.wA = description;
  return $thiz;
}
export { $ct_Lmealorama_MealType__I__T__T__ as $ct_Lmealorama_MealType__I__T__T__ };
/** @constructor */
function $c_Lmealorama_MealType() {
  this.uC = 0;
  this.rk = null;
  this.wA = null;
}
export { $c_Lmealorama_MealType as $c_Lmealorama_MealType };
$p = $c_Lmealorama_MealType.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MealType;
/** @constructor */
function $h_Lmealorama_MealType() {
}
export { $h_Lmealorama_MealType as $h_Lmealorama_MealType };
$h_Lmealorama_MealType.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lmealorama_MealType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "mealorama.MealType", ({
  cb: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lmealorama_MealType as $d_Lmealorama_MealType };
//# sourceMappingURL=mealorama.-Meal-Type.js.map
